window.addEventListener('PandectesEvent_OnInitialize', function (event) {
  function handleElementAdded(element) {
    observer.disconnect();

    let prefsContainer = document.querySelector('#pd-cp-preferences .pd-cp-ui');
    let banner = document.querySelector('.pd-cookie-banner-window');
    let openLink = document.querySelector('.cc-settings');
    if (openLink) {
      const originalOpenOnClick = openLink.onclick;
      openLink.removeAttribute('onclick');
      openLink.addEventListener('click', (e) => {
        panelManager.dispatch('OPEN_COOKIE');
        e.preventDefault();
        element.style.display = 'flex';
        banner.style.visibility = '';
        banner.style.opacity = '0';
        setTimeout(() => {
          banner.style.opacity = '1';
          banner.style.visibility = 'hidden';
        }, 300);
        requestAnimationFrame(() => {
          prefsContainer.classList.add('panel-open');
          originalOpenOnClick();
        });
      });
    }

    let saveLink = document.querySelector('.pd-cp-ui-save');
    if (saveLink) {
      const originalSaveOnClick = saveLink.onclick;
      saveLink.removeAttribute('onclick');
      saveLink.addEventListener('click', function (e) {
        panelManager.dispatch('CLOSE_PANEL');
        e.preventDefault();
        prefsContainer.classList.remove('panel-open');
        setTimeout(function () {
          originalSaveOnClick();
        }, 600);
      });
    }

    let closeLink = document.querySelector('.pd-cp-ui-close-top');
    if (closeLink) {
      const originalCloseOnClick = closeLink.onclick;
      closeLink.removeAttribute('onclick');
      closeLink.addEventListener('click', function (e) {
        e.preventDefault();
        panelManager.dispatch('CLOSE_PANEL');
        prefsContainer.classList.remove('panel-open');
        setTimeout(function () {
          originalCloseOnClick();
        }, 600);
      });
    }

    element.addEventListener('click', function (e) {
      if (e.target !== element) {
        return;
      }
      panelManager.dispatch('CLOSE_PANEL');
      prefsContainer.classList.remove('panel-open');
      setTimeout(() => {
        Pandectes.fn.closePreferences();
      }, 600);
    });
  }

  const targetNode = document.body;
  const config = { childList: true, subtree: false };
  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        for (const addedNode of mutation.addedNodes) {
          if (addedNode.id === 'pd-cp-preferences') {
            handleElementAdded(addedNode);
          }
        }
      }
    }
  };

  const observer = new MutationObserver(callback);

  observer.observe(targetNode, config);
});
